/* Two things the phone menu drawer was missing, kept out of tiger.js.
 *
 * tiger.js already closes the cart tray and any open submenu on Escape — it
 * binds three separate Escape handlers — but never the nav drawer itself, so
 * the one panel that covers the whole screen was the one you could not dismiss
 * from the keyboard. And the drawer had no visible close control at all: you
 * dismissed it by finding the hamburger again, which is a guess, not an
 * affordance.
 *
 * This lives in its own file rather than inside tiger.js because tiger.js is
 * 55 KB of built output; a behaviour this small is not worth rewriting it for.
 * Both paths end in toggle.click(), so tiger.js keeps sole ownership of what
 * "closed" means — the class, the body scroll lock, aria-expanded. Nothing here
 * duplicates that state, which is why nothing here can disagree with it.
 */
(function () {
  'use strict';

  var nav = document.querySelector('.header-nav');
  var toggle = document.querySelector('.menu-toggle');
  if (!nav || !toggle) return;

  function isOpen() {
    return nav.classList.contains('is-open');
  }

  function dismiss() {
    if (!isOpen()) return;
    toggle.click();
    toggle.focus();   // the drawer is going away; put focus back on its opener
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) dismiss();
  });

  /* The label is chosen here rather than pulled from locales/en.default.json:
     the site's Arabic is a client-side class swap, not a Shopify locale, so
     `| t` would answer English whichever language the reader has picked. The
     glyph itself is language-neutral; only the accessible name needs saying
     twice, and it is re-read whenever the language button is used. */
  function label() {
    return (document.documentElement.lang || '').indexOf('ar') === 0
      ? 'إغلاق القائمة'
      : 'Close menu';
  }

  /* Injected from script, not written into header.liquid, because the drawer
     is only ever opened by script — a no-JS page has no drawer to close, and
     so should not be handed a button that does nothing. */
  var close = document.createElement('button');
  close.type = 'button';
  close.className = 'drawer-close';
  close.setAttribute('aria-label', label());
  close.innerHTML = '&times;';
  close.addEventListener('click', dismiss);
  nav.insertBefore(close, nav.firstChild);

  var lang = document.querySelector('.lang-toggle');
  if (lang) {
    lang.addEventListener('click', function () {
      // after tiger.js has rewritten documentElement.lang
      window.setTimeout(function () {
        close.setAttribute('aria-label', label());
      }, 0);
    });
  }
})();
